// src/game/playerName.ts — Oyuncunun ağda görünen adı (view/settings.ts kalıbının aynısı).
//
// NEDEN menüde ve NEDEN kalıcı: adı sormanın gerekçesi ("başkaları seni görecek") çevrimiçi kararının
// yanında duruyor; her oturumda yeniden yazdırmak ise gereksiz. Lobide ad alanı YOK — `NetClient.hello()`
// adı kurulum seçeneklerinden okuyor ve bir kez gönderiliyor, tek doğruluk kaynağı bağlanmadan öncesi.

/** localStorage anahtarı. */
const NAME_KEY = 'ringout.name';
/** Sunucunun `Room.hello` içindeki kırpmasıyla AYNI sayı olmak zorunda — kullanıcı menüde yazdığının
 *  lobide kısaldığını görmesin. */
export const MAX_NAME_LEN = 24;

/** Kontrol karakterleri (satır sonu dahil): ada girerse lobi satırını bozar. */
const CONTROL = /[\u0000-\u001f\u007f-\u009f]/g;

/**
 * Görünen ada çevirir: kontrol karakterleri boşluğa döner, baştaki/sondaki boşluk atılır, uzunluk
 * KOD NOKTASI bazında kırpılır (`slice` emojiyi ortadan bölüp bozuk bir karakter bırakırdı).
 */
export function sanitizeName(raw: string): string {
  const clean = raw.replace(CONTROL, ' ').trim();
  const cps = [...clean];
  return cps.length <= MAX_NAME_LEN ? clean : cps.slice(0, MAX_NAME_LEN).join('');
}

/** Depolama erişimi gizli sekmede İSTİSNA atabilir; ad uğruna açılış çökmesin. */
export function saveName(name: string): void {
  try { localStorage.setItem(NAME_KEY, name); } catch { /* depolama kapalı: ad yalnız bu oturumda kalır */ }
}

/**
 * Açılış adı. Öncelik: `?name=` (kazanır ve KAYDEDİLİR — bir kez verilen ad sonraki açılışlarda da kalsın,
 * settings.ts'in `?mute=` kuralının aynısı) > localStorage > BOŞ.
 *
 * Varsayılan boş, 'oyuncu' DEĞİL: sunucu boş adı `P1`/`P2` yapıyor (Room.join/hello), yani ad girmeyen
 * bir odada herkes "oyuncu" olmak yerine koltuk numarasıyla ayırt ediliyor.
 */
export function loadPlayerName(search = ''): string {
  const given = new URLSearchParams(search).get('name');
  if (given !== null) {
    const n = sanitizeName(given);
    if (n) { saveName(n); return n; }
  }
  try { return sanitizeName(localStorage.getItem(NAME_KEY) ?? ''); } catch { return ''; }
}
